const PRIMARY_COUNTRIES = [
  {
    code: 'us',
    name: 'United States',
  },
  {
    code: 'gb',
    name: 'United Kingdom',
  },
  {
    code: 'nl',
    name: 'Netherlands',
  },
];

module.exports = PRIMARY_COUNTRIES;
